export default __webpack_public_path__ + "static/media/M16.ab7a2bff.jpg";